import script from "./showText.vue?vue&type=script&setup=true&lang=js"
export * from "./showText.vue?vue&type=script&setup=true&lang=js"

import "./showText.vue?vue&type=style&index=0&id=cb1979de&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb1979de"]])

export default __exports__